import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductCardOnDisplayInShowroom from 'components/consumer/product-card/ProductCardOnDisplayInShowroom';
import Link from 'components/consumer/Link';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useProductCardContext from 'data-hooks/useProductCardContext';
import ProductCardLabelUI from 'components/consumer/product-card/ProductCardLabel/ProductCardLabelUI';
import ProductCardNameUI from 'components/consumer/product-card/ProductCardNameUI';
import ProductCardPriceUI from 'components/consumer/product-card/ProductCardPrice/ProductCardPriceUI';
import IconQuickship from 'components/icons/iconQuickship';
import { colorGrayLight2 } from 'styles/layout/colors';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import ProductCardSwatchesNewUI from 'components/consumer/product-card/ProductCardSwatches/ProductCardSwatchesNewUI';
import ProductCardOptionsUI from 'components/consumer/product-card/ProductCardOptions/ProductCardOptionsUI';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import useCloseSearch from 'global-state/isSearchOpen/useCloseSearch';
import ProductCardPhotoSquare from './components/ProductCardPhotoSquare';
import ProductCardFavoriteButton from './components/ProductCardFavoriteButton';
const ProductCardStaticUI = t0 => {
  const $ = _c(93);
  const {
    analyticsComponentName,
    disableImageLazyLoading,
    prioritizeImage,
    hidden,
    enableMobileCarousel,
    onClick,
    isHotspotCard: t1,
    layout
  } = t0;
  const isHotspotCard = t1 === undefined ? false : t1;
  const history = useHistory();
  const {
    id,
    image,
    isClearance,
    isOutOfStock,
    label: t2,
    loading,
    minPrice,
    name,
    originalPrice,
    path,
    position,
    price,
    productFamily,
    productLabel,
    productType,
    quickship,
    showAttributes,
    showProductLabel,
    showShowroomInfo,
    showStockInfo,
    showSwatches,
    sku,
    slug,
    upholsteryThumbnail,
    variantsToShow
  } = useProductCardContext();
  const label = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== path || $[1] !== slug) {
    t3 = path && String(path) !== "null" && path.startsWith("/") ? path : slug ? `/products/${slug}/` : "#";
    $[0] = path;
    $[1] = slug;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const safePath = t3;
  const currentPage = useUserCurrentPageType();
  const {
    data: pdpClearanceData
  } = usePDPClearanceData();
  const closeSearch = useCloseSearch();
  let t4;
  if ($[3] !== analyticsComponentName || $[4] !== currentPage || $[5] !== id || $[6] !== isClearance || $[7] !== label || $[8] !== name || $[9] !== originalPrice || $[10] !== pdpClearanceData?.optionsClearanceData || $[11] !== position || $[12] !== price || $[13] !== productFamily || $[14] !== productType || $[15] !== quickship || $[16] !== sku) {
    t4 = () => {
      const clearanceDataKeys = Object.keys(pdpClearanceData?.optionsClearanceData ?? {});
      avo.productClicked({
        category: productType,
        component: analyticsComponentName,
        contentIds: [(sku ?? "").split("-")[0]],
        currency: "USD",
        fullPrice: parseFloat(originalPrice),
        isClearance,
        location: currentPage,
        name,
        position,
        price: parseFloat(price),
        productFamily,
        productId: id,
        quantity: 1,
        quickship,
        sku,
        variant: label,
        isFlashSale: clearanceDataKeys.includes(sku)
      });
    };
    $[3] = analyticsComponentName;
    $[4] = currentPage;
    $[5] = id;
    $[6] = isClearance;
    $[7] = label;
    $[8] = name;
    $[9] = originalPrice;
    $[10] = pdpClearanceData?.optionsClearanceData;
    $[11] = position;
    $[12] = price;
    $[13] = productFamily;
    $[14] = productType;
    $[15] = quickship;
    $[16] = sku;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const trackProductClicked = t4;
  let t5;
  if ($[18] !== closeSearch || $[19] !== history || $[20] !== image || $[21] !== minPrice || $[22] !== name || $[23] !== onClick || $[24] !== originalPrice || $[25] !== price || $[26] !== safePath || $[27] !== trackProductClicked) {
    t5 = event => {
      trackProductClicked(event);
      if (event.ctrlKey || event.metaKey) {
        return;
      }
      event.preventDefault();
      onClick?.();
      closeSearch();
      if (safePath.startsWith("/modular/") || safePath.startsWith("/modulars/")) {
        window.location.href = safePath;
      } else {
        if (safePath !== "#") {
          history.push(safePath, {
            image,
            minPrice,
            name,
            originalPrice,
            price
          });
        }
      }
    };
    $[18] = closeSearch;
    $[19] = history;
    $[20] = image;
    $[21] = minPrice;
    $[22] = name;
    $[23] = onClick;
    $[24] = originalPrice;
    $[25] = price;
    $[26] = safePath;
    $[27] = trackProductClicked;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  const onProductClick = t5;
  const labelStr = label != null ? String(label) : "";
  let t6;
  if ($[29] !== labelStr) {
    t6 = labelStr.split(",")?.[0] ?? "";
    $[29] = labelStr;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  const shortLabel = t6;
  let t7;
  if ($[31] !== labelStr) {
    t7 = labelStr.split(",").slice(1).map(_temp);
    $[31] = labelStr;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  const otherLabels = t7;
  let t8;
  if ($[33] !== hidden || $[34] !== isHotspotCard) {
    t8 = classNames("rounded-sm relative text-gray [transition:all_0.25s_ease-in-out] pb-2 md:pb-0", {
      "!rounded-lg !p-2.5": isHotspotCard
    }, {
      hidden
    });
    $[33] = hidden;
    $[34] = isHotspotCard;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== disableImageLazyLoading || $[37] !== enableMobileCarousel || $[38] !== prioritizeImage) {
    t9 = <ProductCardPhotoSquare disableImageLazyLoading={disableImageLazyLoading} prioritizeImage={prioritizeImage} enableMobileCarousel={enableMobileCarousel} />;
    $[36] = disableImageLazyLoading;
    $[37] = enableMobileCarousel;
    $[38] = prioritizeImage;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== name) {
    t10 = <ProductCardNameUI name={name} />;
    $[40] = name;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  const t11 = !!price && (!!originalPrice && originalPrice !== price || !!minPrice && minPrice !== price);
  const t12 = originalPrice ?? price;
  let t13;
  if ($[42] !== loading || $[43] !== minPrice || $[44] !== price || $[45] !== t11 || $[46] !== t12) {
    t13 = <ProductCardPriceUI hasDiscount={t11} loading={loading} minPrice={minPrice} originalPrice={t12} salePrice={price} />;
    $[42] = loading;
    $[43] = minPrice;
    $[44] = price;
    $[45] = t11;
    $[46] = t12;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== t10 || $[49] !== t13) {
    t14 = <div className="min-h-[4.6rem] min-w-0">{t10}{t13}</div>;
    $[48] = t10;
    $[49] = t13;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== quickship || $[52] !== showStockInfo) {
    t15 = showStockInfo && !!quickship && <div className="text-xs flex items-center text-gray-light1 mt-1 gap-2"><IconQuickship color={colorGrayLight2} width={18} height={12} /><span>Ready to ship</span></div>;
    $[51] = quickship;
    $[52] = showStockInfo;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== isOutOfStock || $[55] !== showStockInfo) {
    t16 = showStockInfo && !!isOutOfStock && <div className="text-xs text-red mt-1">Out of stock</div>;
    $[54] = isOutOfStock;
    $[55] = showStockInfo;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== t15 || $[58] !== t16) {
    t17 = <div className="shrink-0 xl:mt-0 xl:ml-auto">{t15}{t16}</div>;
    $[57] = t15;
    $[58] = t16;
    $[59] = t17;
  } else {
    t17 = $[59];
  }
  let t18;
  if ($[60] !== t14 || $[61] !== t17) {
    t18 = <div className="flex flex-col gap-1 xl:flex-row xl:flex-wrap xl:items-end xl:gap-x-2 xl:gap-y-0 w-full px-[10px] md:px-0 pb-2 relative">{t14}{t17}</div>;
    $[60] = t14;
    $[61] = t17;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  let t19;
  if ($[63] !== otherLabels || $[64] !== shortLabel || $[65] !== showAttributes || $[66] !== upholsteryThumbnail) {
    t19 = showAttributes && (!!shortLabel || !!otherLabels.length) && <ProductCardOptionsUI fabricSelectedOption={{
      label: shortLabel,
      image: upholsteryThumbnail
    }} productOptions={otherLabels} />;
    $[63] = otherLabels;
    $[64] = shortLabel;
    $[65] = showAttributes;
    $[66] = upholsteryThumbnail;
    $[67] = t19;
  } else {
    t19 = $[67];
  }
  let t20;
  if ($[68] !== productLabel || $[69] !== showProductLabel) {
    t20 = showProductLabel && !!productLabel && <ProductCardLabelUI label={productLabel} />;
    $[68] = productLabel;
    $[69] = showProductLabel;
    $[70] = t20;
  } else {
    t20 = $[70];
  }
  let t21;
  if ($[71] !== layout) {
    t21 = layout !== "mini" && <div className="absolute top-5 right-5 group-hover:opacity-100"><ProductCardFavoriteButton /></div>;
    $[71] = layout;
    $[72] = t21;
  } else {
    t21 = $[72];
  }
  let t22;
  if ($[73] !== name || $[74] !== onProductClick || $[75] !== safePath || $[76] !== t18 || $[77] !== t19 || $[78] !== t20 || $[79] !== t21 || $[80] !== t9) {
    t22 = <Link onClick={onProductClick} to={safePath} aria-label={name} className="block hover:!no-underline group/product-card">{t9}{t18}{t19}{t20}{t21}</Link>;
    $[73] = name;
    $[74] = onProductClick;
    $[75] = safePath;
    $[76] = t18;
    $[77] = t19;
    $[78] = t20;
    $[79] = t21;
    $[80] = t9;
    $[81] = t22;
  } else {
    t22 = $[81];
  }
  let t23;
  if ($[82] !== onProductClick || $[83] !== showSwatches || $[84] !== variantsToShow?.length) {
    t23 = showSwatches && variantsToShow?.length >= 2 && <TabletAndDesktopOnly><div className="max-[767px]:hidden"><ProductCardSwatchesNewUI onProductClick={onProductClick} /></div></TabletAndDesktopOnly>;
    $[82] = onProductClick;
    $[83] = showSwatches;
    $[84] = variantsToShow?.length;
    $[85] = t23;
  } else {
    t23 = $[85];
  }
  let t24;
  if ($[86] !== showShowroomInfo) {
    t24 = showShowroomInfo && <div className="mt-2"><ProductCardOnDisplayInShowroom /></div>;
    $[86] = showShowroomInfo;
    $[87] = t24;
  } else {
    t24 = $[87];
  }
  let t25;
  if ($[88] !== t22 || $[89] !== t23 || $[90] !== t24 || $[91] !== t8) {
    t25 = <div className={t8}>{t22}{t23}{t24}</div>;
    $[88] = t22;
    $[89] = t23;
    $[90] = t24;
    $[91] = t8;
    $[92] = t25;
  } else {
    t25 = $[92];
  }
  return t25;
};
ProductCardStaticUI.propTypes = {
  analyticsComponentName: PropTypes.string,
  hidden: PropTypes.bool,
  isHotspotCard: PropTypes.bool,
  enableMobileCarousel: PropTypes.bool,
  onClick: PropTypes.func,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom'])
};
export default ProductCardStaticUI;
function _temp(item) {
  return item.trim();
}